interface CityListProps {
  cities: Array<{
    id: string;
    name: string;
    emoji: string;
    available?: boolean;
  }>;
  selectedCityId: string;
  onSelectCity: (cityId: string) => void;
  /** Override the backend's availability with custom logic (e.g., event-based availability) */
  availableCityIds?: Set<string>;
}

export function CityList({
  cities,
  selectedCityId,
  onSelectCity,
  availableCityIds,
}: CityListProps) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
      {cities.map((city) => {
        // Use custom availability if provided, otherwise use backend availability
        const isAvailable = availableCityIds
          ? availableCityIds.has(city.id)
          : city.available !== false;
        const isSelected = selectedCityId === city.id;

        return (
          <button
            key={city.id}
            onClick={() => {
              if (isAvailable) {
                onSelectCity(city.id);
              }
            }}
            disabled={!isAvailable}
            className={`
              p-4 rounded-lg transition-all text-left flex items-center justify-between border border-divider
              ${isSelected ? "bg-primary-50 dark:bg-primary-900/50 border-primary-500 border" : "bg-dark-elevated border border-transparent hover:border-primary-500/50"}
              ${!isAvailable ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}
            `}
          >
            <div>
              <div className="font-semibold text-sm mb-1 dark:text-neutral-100">
                {city.name}
              </div>
              {!isAvailable && (
                <div className="text-xs text-dark-muted dark:text-neutral-500">
                  Coming Soon
                </div>
              )}
            </div>
            <span className="text-2xl">{city.emoji}</span>
          </button>
        );
      })}
    </div>
  );
}

